import request from '@/utils/request'

/**
 *  推广位报表
 * @param {*} data 
 */
export function appMovieDayStatistics(data) {
    return request({
      url: '/index/promotion/appMovieDayStatistics',
      method: 'post',
      data
    })
}

/**
 *  有api权限的推广位
 * @param {*} data 
 */
export function getAppApiList(data) {
    return request({
      url: '/index/promotion/appApiList',
      method: 'post',
      data
    })
}



/**
 *  推广位列表
 * @param {*} data 
 */
export function getPromotionList(data) {
    return request({
      url: '/index/promotion/promotionManage',
      method: 'post',
      data
    })
}
/**
 *  推广位创建
 * @param {*} data 
 */
export function createPromotion(data) {
    return request({
      url: '/index/promotion/createPromotion',
      method: 'post',
      data
    })
}

/**
 *  推广位编辑
 * @param {*} data 
 */
export function editPromotion(data) {
    return request({
      url: '/index/promotion/editPromotion',
      method: 'post',
      data
    })
}

/**
 *  推广位appSecret重置
 * @param {*} data 
 */
export function appSecretReset(data) {
  return request({
    url: '/index/promotion/appSecretReset',
    method: 'post',
    data
  })
}


export function index(data) {
  return request({
    url: '/index/promotion/index',
    method: 'post',
    data
  })
}

/**
 * 首页推广位列表
 * @param {*} data 
 */
export function getIndexAppList(data) {
  return request({
    url: '/index/promotion/indexAppList',
    method: 'post',
    data
  })
}






// WEBPACK FOOTER //
// ./src/api/promotion.js